// SpendingIcon.js
import React from 'react';

/**
 * SpendingIcon
 *
 * The dollar glyph the Spending topic uses, shared by the bottom navbar's
 * Spending tab and the mobile menu's Topics list so the two can never drift
 * apart. Material Symbols' "attach_money" path, drawn in currentColor, so it
 * takes whatever color its parent sets (the navbar's active and inactive
 * icon classes, the menu's text color).
 *
 * There is no filled variant of this glyph. The bottom navbar carries the
 * active state with the pill background and icon color instead, as it does
 * for Elections.
 */
const SpendingIcon = ({ size = 20, className, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 -960 960 960"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path d="M444-144v-80q-51-11-87.5-46T305-357l74-30q8 36 40.5 64.5T487-294q39 0 64-20t25-52q0-30-22.5-50T474-456q-78-28-114-61.5T324-604q0-50 32.5-86t87.5-47v-79h72v79q72 12 96.5 55t25.5 45l-70 29q-8-26-32-43t-53-17q-35 0-58 18t-23 44q0 26 25 44.5t93 41.5q70 23 102 60t32 94q0 57-37 96t-101 49v77h-72Z" />
  </svg>
);

export default SpendingIcon;